import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TireSearch } from './components/TireSearch';
import { MembershipProgram } from './components/MembershipProgram';
import { Services } from './components/Services';
import { TireShop } from './components/TireShop';
import { BookingForm } from './components/BookingForm';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingRoadsideButton } from './components/FloatingRoadsideButton';
import { AdminProvider, useAdmin } from './context/AdminContext';
import { ProviderProvider } from './context/ProviderContext';
import { CartProvider } from './context/CartContext';
import { AdminLogin } from './components/admin/AdminLogin';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { RoadsidePage } from './pages/RoadsidePage';
import { ProviderSignupPage } from './pages/ProviderSignupPage';
import { ProviderLoginPage } from './pages/ProviderLoginPage';
import { ProviderDashboard } from './pages/ProviderDashboard';
import { ProviderApplicationPage } from './pages/ProviderApplicationPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { BlogPage } from './pages/BlogPage';
import { CarCareTipsCTA } from './components/CarCareTipsCTA';
import { LatestCarCareTips } from './components/LatestCarCareTips';
import { StructuredData } from './components/StructuredData';
import { homepageStructuredData } from './seo/structuredData';
import { SiteVerification } from './components/SiteVerification';
import { GoogleAnalytics } from './components/GoogleAnalytics';

const Home = () => {
  return (
    <div className="min-h-screen">
      <StructuredData id="ld-home-business" data={homepageStructuredData} />
      <Header />
      <Hero />
      <TireSearch />
      <MembershipProgram />
      <Services />
      <TireShop />
      <BookingForm />
      <Testimonials />
      <Contact />
      <LatestCarCareTips />
      <CarCareTipsCTA />
      <Footer />
      <FloatingRoadsideButton />
    </div>
  );
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAdmin();
  
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-xl text-gray-600">Loading...</p>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <div className="App">
      <SiteVerification />
      <AdminProvider>
        <ProviderProvider>
          <CartProvider>
            <BrowserRouter>
              <GoogleAnalytics />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/roadside" element={<RoadsidePage />} />
                <Route path="/apply-provider" element={<ProviderApplicationPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route 
                  path="/admin/dashboard" 
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                {/* Provider Routes */}
                <Route path="/provider/signup" element={<ProviderSignupPage />} />
                <Route path="/provider/login" element={<ProviderLoginPage />} />
                <Route path="/provider/dashboard" element={<ProviderDashboard />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </CartProvider>
        </ProviderProvider>
      </AdminProvider>
    </div>
  );
}

export default App;
